/* Fuego & Fragancia — mantiene el rating (estrellas + texto) siempre en un
   solo renglón, reduciendo el tamaño del texto en lugar de dejarlo partirse
   en dos líneas o cortarse con puntos suspensivos. Funciona con cualquier
   texto que se escriba en el editor. También puede navegar (URL o scroll a
   una sección de la misma página) si se le pasa un link. */

if (!customElements.get('ff-rating-stars')) {
  customElements.define(
    'ff-rating-stars',
    class FfRatingStars extends HTMLElement {
      // Piso bajo a propósito: el requisito es que el texto NUNCA quede
      // incompleto, así que se prioriza que quepa completo sobre mantener
      // un tamaño mínimo "legible".
      static MIN_SCALE = 0.4;
      static MAX_PASSES = 4;

      connectedCallback() {
        this.label = this.querySelector('.ff-rating-stars__label');
        this.icons = this.querySelector('.ff-rating-stars__icons');
        if (!this.label || !this.icons) return;

        this.fit();

        if ('ResizeObserver' in window) {
          // El ancho disponible cambia con la ventana y también cuando el
          // hero o la tarjeta que lo contiene cambian de layout.
          this.resizeObserver = new ResizeObserver(() => this.fit());
          this.resizeObserver.observe(this.parentElement || this);
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', () => this.fit());
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.fit());
        }

        this.initLink();
      }

      fit() {
        // Se mide siempre a escala 1 antes de decidir: si no se resetea
        // primero, una reducción previa falsearía la medición siguiente.
        this.style.setProperty('--ff-rating-scale', 1);
        this.adjust(0);
      }

      // Varias pasadas cortas en vez de una sola: cada corrección se basa en
      // una medición fresca, así que converge incluso si la primera
      // estimación se queda corta por redondeo o por el piso mínimo.
      adjust(pass) {
        const available = this.clientWidth;
        const needed = this.icons.getBoundingClientRect().width + this.label.scrollWidth + this.gapPx();

        if (!available || needed <= available) return;

        const current = parseFloat(this.style.getPropertyValue('--ff-rating-scale')) || 1;
        let scale = current * (available / needed);
        scale = Math.max(FfRatingStars.MIN_SCALE, Math.min(1, scale));
        this.style.setProperty('--ff-rating-scale', scale.toFixed(3));

        if (pass < FfRatingStars.MAX_PASSES && scale > FfRatingStars.MIN_SCALE) {
          requestAnimationFrame(() => this.adjust(pass + 1));
        }
      }

      gapPx() {
        return parseFloat(getComputedStyle(this).columnGap || getComputedStyle(this).gap || '8') || 8;
      }

      initLink() {
        const link = this.dataset.link;
        if (!link) return;

        this.classList.add('ff-rating-stars--linked');
        this.setAttribute('role', 'link');
        this.setAttribute('tabindex', '0');

        const go = () => {
          if (link.charAt(0) === '#') {
            const target = document.getElementById(link.slice(1)) || document.querySelector(link);
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              return;
            }
          }
          window.location.href = link;
        };

        this.addEventListener('click', go);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          go();
        });
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
    }
  );
}
